import {ProductCompositionsData} from "../types/product-compositions-modal.types";

export const defaultProductCompositionsData: ProductCompositionsData = {
  id: 0,
  compositionTitle: 'Новый',
  comment: ''
}
